export const isPcpDirty = (formState): boolean =>
  [
    'attachments',
    'allowFreeDownload',
    'downloadDollarPrice',
    'originalAttached',
    'showAttachments',
  ].reduce((acc, k) => acc || !!formState?.dirtyFields[k], false);
